// The shopping list's copy (ticket 374, docs/tickets/374/design.md), authored in nl and en. i18n's
// locale files spread these into their two dictionaries; the other five locales read nl until the
// words exist for them. Every string is ours: no outside body, no shop, no price, no link, and no
// wine name beyond the grape and place names the lines carry. The group list's and the notice's
// copy sits here too, so one place answers "what does the wine list say".
export const shopCopy = {
  nl: {
    // Entries and the deferred taste step
    "learn.shop.entry": "Wijnen voor dit niveau",
    "learn.shop.entry-hint": "Koop op tijd wat je nodig hebt · {have} van {total} in huis",
    "learn.shop.entry-hint-empty": "Koop op tijd wat je nodig hebt",
    "learn.shop.section-ahead": "Plan vooruit",
    "learn.shop.defer-need-1": "Je hebt 1 wijn nodig voor deze proefstap",
    "learn.shop.defer-need-n": "Je hebt {n} wijnen nodig voor deze proefstap",
    "learn.shop.defer-more-1": "Je hebt nog 1 wijn nodig voor deze proefstap",
    "learn.shop.defer-more-n": "Je hebt nog {n} wijnen nodig voor deze proefstap",
    "learn.shop.defer-have-all": "De wijnen heb je in huis",
    "learn.shop.defer-have-all-body":
      "Alles voor deze proefstap staat op 'heb ik'. Begin de proeverij of kijk de lijst nog even na.",
    "learn.shop.have-them": "Ik heb ze",
    "learn.shop.have-it": "Ik heb hem",
    "learn.shop.show-on-list": "Toon op de lijst",
    "learn.shop.start-tasting": "Begin de proeverij",
    "learn.shop.review-list": "Bekijk de lijst",
    "learn.shop.dismiss": "Sluiten",
    "learn.shop.done-noted": "Genoteerd: de wijnen voor deze stap staan op 'heb ik'.",
    "learn.shop.undo-on-list": "Ongedaan maken op de lijst",
    "learn.shop.fit-note": "Elke fles die past, past.",
    // The list
    "learn.shop.title": "Wijnen voor dit niveau",
    "learn.shop.count": "{have} van {total} heb je in huis",
    "learn.shop.sub": "Eén fles per regel. Je hoeft niet alles te hebben om te beginnen.",
    "learn.shop.next-title": "Eerst nodig",
    "learn.shop.next-hint": "De volgende {n} lessen",
    "learn.shop.later-title": "Later in dit niveau",
    "learn.shop.rest-title": "De rest, per module",
    "learn.shop.module-papers": "Papers",
    "learn.shop.hide-have": "Verberg wat ik heb",
    "learn.shop.hide-hint": "Staat aan voor dit bezoek; een nieuw bezoek begint weer met alles.",
    "learn.shop.hidden-n": "{n} verborgen",
    "learn.shop.show-have": "Toon wat ik heb ({n})",
    "learn.shop.state-have": "Heb ik",
    "learn.shop.state-need": "Nodig",
    "learn.shop.hard": "Lastige aankoop",
    "learn.shop.lessons-for": "Nodig voor: {lessons}",
    "learn.shop.module-count": "{n} wijnen · {have} heb ik",
    "learn.shop.shelf-title": "Open een fles pas als je gaat proeven",
    "learn.shop.shelf":
      "Een open fles houdt het een paar dagen vol: stil 3–5 dagen, bruisend 1–2. Kleine schenk, spugen mag.",
    "learn.shop.lesson-title": "Wijnen voor deze les",
    "learn.shop.lesson-step": "Voor de proefstap",
    "learn.shop.whole-level": "Bekijk het hele niveau",
    "learn.shop.all-have": "Alles staat op 'heb ik'.",
    "learn.shop.empty-title": "Dit niveau vraagt geen wijn",
    "learn.shop.empty-body":
      "Er staan geen proefstappen in. Je hoeft niets te kopen; lezen en oefenen werken zonder glas.",
    "learn.shop.back": "Terug naar het pad",
    "learn.shop.error-title": "De wijnen van dit niveau konden niet worden geladen",
    "learn.shop.error-body":
      "De inhoud van een niveau wordt apart geladen. Probeer opnieuw; je vinkjes en de rest van de app werken gewoon.",
    "learn.shop.retry": "Opnieuw laden",
    "learn.shop.offline":
      "Geen verbinding. De lijst staat op je toestel; je vinkjes worden bewaard en gaan mee zodra je weer verbinding hebt.",
    "learn.shop.share": "Deel de lijst",
    // Export
    "learn.shop.export-title": "Deel de lijst",
    "learn.shop.scope-label": "Wat deel je",
    "learn.shop.scope-all": "Alles",
    "learn.shop.scope-need": "Alleen wat ik nog nodig heb",
    "learn.shop.preview": "Zo ziet de tekst eruit",
    "learn.shop.export-share": "Deel",
    "learn.shop.export-copy": "Kopieer",
    "learn.shop.export-print": "Print",
    "learn.shop.export-empty": "Er is niets om te delen: alles staat al op 'heb ik'.",
    "learn.shop.copied": "Gekopieerd. Plak de lijst waar je wilt.",
    "learn.shop.copy-failed": "Kopiëren lukte niet",
    "learn.shop.copy-failed-body": "Selecteer de tekst hieronder en kopieer hem zelf.",
    "learn.shop.no-share": "Dit toestel heeft geen deelmenu. Kopiëren en printen werken wel.",
    // The group's wine list
    "social.shop.title": "Wijnenlijst",
    "social.shop.entry": "Wijnenlijst · Niveau {n}",
    "social.shop.entry-meta": "{n} leden delen wat ze hebben",
    "social.shop.entry-meta-none": "Nog niemand deelt wat hij of zij heeft",
    "social.shop.off-title": "De groep heeft nog geen wijnenlijst",
    "social.shop.off-body":
      "Vraag een beheerder of eigenaar om er een aan te zetten. Jouw eigen lijst werkt gewoon.",
    "social.shop.setup-title": "Zet een wijnenlijst aan voor de groep",
    "social.shop.setup-body":
      "Eén niveau, dezelfde lijst voor iedereen. Leden kiezen zelf of ze meedoen.",
    "social.shop.setup-open": "Wijnenlijst instellen",
    "social.shop.switch": "Wijnenlijst voor de groep",
    "social.shop.switch-hint": "Alle leden zien dezelfde lijst voor één niveau.",
    "social.shop.level": "Niveau",
    "social.shop.level-hint":
      "Het niveau wisselen kan altijd: vinkjes voor wijnen die op de nieuwe lijst blijven staan, blijven staan.",
    "social.shop.who-title": "Wie doet mee?",
    "social.shop.who-body":
      "Niemand tot hij of zij het zelf kiest. Leden zien alleen wie van de meedoende leden welke wijn heeft.",
    "social.shop.done": "Klaar",
    "social.shop.off-confirm-title": "De wijnenlijst uitzetten?",
    "social.shop.off-confirm-body":
      "De lijst verdwijnt voor iedereen in de groep en alle gedeelde vinkjes van deze groep worden gewist. Persoonlijke vinkjes blijven staan. Aanzetten kan later opnieuw, met een lege lijst.",
    "social.shop.off-confirm-yes": "Zet uit en wis de gedeelde vinkjes",
    "social.shop.off-confirm-no": "Laat aan",
    "social.shop.offer-title": "Deel wat je hebt met {group}",
    "social.shop.offer-body":
      "De groep ziet welke wijnen je hebt aangevinkt, met je naam. Wat je nu al aanvinkte voor niveau {n} gaat mee. Je kunt altijd stoppen.",
    "social.shop.offer-yes": "Deel met de groep",
    "social.shop.offer-no": "Nu niet",
    "social.shop.stop": "Stop met delen",
    "social.shop.sharing-count": "{n} leden delen",
    "social.shop.sharing-count-1": "1 lid deelt",
    "social.shop.nobody-sharing": "Niemand deelt nog",
    "social.shop.you-share": "Jij deelt met deze groep.",
    "social.shop.has-you": "Jij heeft deze",
    "social.shop.has-you-and": "Jij en {name} hebben deze",
    "social.shop.has-you-and-many": "Jij en {names} hebben deze",
    "social.shop.has-one": "{name} heeft deze",
    "social.shop.has-many": "{names} hebben deze",
    "social.shop.nobody": "Nog niemand heeft deze",
    "social.shop.ask-title": "Delen met {group}?",
    "social.shop.ask-body":
      "Deel je dit vinkje, dan ziet de groep het met je naam, samen met je andere vinkjes voor niveau {n}. Kies je 'Alleen voor mij', dan vink je alleen je eigen lijst aan.",
    "social.shop.ask-share": "Deel en vink aan",
    "social.shop.ask-private": "Alleen voor mij",
    "social.shop.offline":
      "Geen verbinding. Dit is de laatst geziene lijst en hij kan verouderd zijn.",
    "social.shop.last-seen": "laatst gezien {when}",
    "social.shop.error-title": "De lijst van de groep kon niet worden geladen",
    "social.shop.error-body": "De rest van de groep werkt gewoon. Probeer het zo nog eens.",
    "social.shop.retry": "Opnieuw proberen",
    "social.shop.off-notice": "De wijnenlijst van deze groep staat uit.",
    "social.shop.share-list": "Deel de lijst",
    // The notice a member's tick earns
    "notify.shop.inbox-item": "{name} heeft een wijn op de lijst van {group}",
    "notify.shop.offline-open":
      "Geen verbinding. Je ziet de laatst bewaarde lijst; hij kan verouderd zijn.",
  },
  en: {
    "learn.shop.entry": "Wines for this level",
    "learn.shop.entry-hint": "Get what you need in time · {have} of {total} on hand",
    "learn.shop.entry-hint-empty": "Get what you need in time",
    "learn.shop.section-ahead": "Plan ahead",
    "learn.shop.defer-need-1": "You need 1 wine for this taste step",
    "learn.shop.defer-need-n": "You need {n} wines for this taste step",
    "learn.shop.defer-more-1": "You still need 1 wine for this taste step",
    "learn.shop.defer-more-n": "You still need {n} wines for this taste step",
    "learn.shop.defer-have-all": "The wines are on hand",
    "learn.shop.defer-have-all-body":
      "Everything for this taste step is ticked. Start the tasting or look the list over once more.",
    "learn.shop.have-them": "I have them",
    "learn.shop.have-it": "I have it",
    "learn.shop.show-on-list": "Show on the list",
    "learn.shop.start-tasting": "Start the tasting",
    "learn.shop.review-list": "Review the list",
    "learn.shop.dismiss": "Close",
    "learn.shop.done-noted": "Noted: the wines for this step are on 'have'.",
    "learn.shop.undo-on-list": "Undo on the list",
    "learn.shop.fit-note": "Any bottle that fits, fits.",
    "learn.shop.title": "Wines for this level",
    "learn.shop.count": "{have} of {total} on hand",
    "learn.shop.sub": "One bottle per line. You do not need everything to begin.",
    "learn.shop.next-title": "Needed first",
    "learn.shop.next-hint": "The next {n} lessons",
    "learn.shop.later-title": "Later in this level",
    "learn.shop.rest-title": "The rest, by module",
    "learn.shop.module-papers": "Papers",
    "learn.shop.hide-have": "Hide what I have",
    "learn.shop.hide-hint": "On for this visit; a new visit starts with everything again.",
    "learn.shop.hidden-n": "{n} hidden",
    "learn.shop.show-have": "Show what I have ({n})",
    "learn.shop.state-have": "Have",
    "learn.shop.state-need": "Needed",
    "learn.shop.hard": "Hard purchase",
    "learn.shop.lessons-for": "Needed for: {lessons}",
    "learn.shop.module-count": "{n} wines · {have} on hand",
    "learn.shop.shelf-title": "Open a bottle only when you are going to taste",
    "learn.shop.shelf":
      "An open bottle keeps for a few days: still 3–5 days, sparkling 1–2. Small pour, spitting is fine.",
    "learn.shop.lesson-title": "Wines for this lesson",
    "learn.shop.lesson-step": "For the taste step",
    "learn.shop.whole-level": "See the whole level",
    "learn.shop.all-have": "Everything is on 'have'.",
    "learn.shop.empty-title": "This level asks for no wine",
    "learn.shop.empty-body":
      "It has no taste steps. There is nothing to buy; reading and practice work without a glass.",
    "learn.shop.back": "Back to the path",
    "learn.shop.error-title": "The wines of this level could not be loaded",
    "learn.shop.error-body":
      "A level's content loads on its own. Try again; your ticks and the rest of the app work as usual.",
    "learn.shop.retry": "Load again",
    "learn.shop.offline":
      "No connection. The list is on your device; your ticks are kept and sync as soon as you are back online.",
    "learn.shop.share": "Share the list",
    "learn.shop.export-title": "Share the list",
    "learn.shop.scope-label": "What you share",
    "learn.shop.scope-all": "Everything",
    "learn.shop.scope-need": "Only what I still need",
    "learn.shop.preview": "How the text looks",
    "learn.shop.export-share": "Share",
    "learn.shop.export-copy": "Copy",
    "learn.shop.export-print": "Print",
    "learn.shop.export-empty": "There is nothing to share: everything is already on 'have'.",
    "learn.shop.copied": "Copied. Paste the list wherever you like.",
    "learn.shop.copy-failed": "Copying did not work",
    "learn.shop.copy-failed-body": "Select the text below and copy it yourself.",
    "learn.shop.no-share": "This device has no share menu. Copy and print still work.",
    "social.shop.title": "Wine list",
    "social.shop.entry": "Wine list · Level {n}",
    "social.shop.entry-meta": "{n} members share what they have",
    "social.shop.entry-meta-none": "Nobody shares what they have yet",
    "social.shop.off-title": "The group has no wine list yet",
    "social.shop.off-body":
      "Ask an admin or the owner to switch one on. Your own list works as usual.",
    "social.shop.setup-title": "Switch on a wine list for the group",
    "social.shop.setup-body":
      "One level, the same list for everyone. Members choose for themselves whether to take part.",
    "social.shop.setup-open": "Set up the wine list",
    "social.shop.switch": "Wine list for the group",
    "social.shop.switch-hint": "All members see the same list for one level.",
    "social.shop.level": "Level",
    "social.shop.level-hint":
      "You can change the level at any time: ticks for wines that stay on the new list stay.",
    "social.shop.who-title": "Who takes part?",
    "social.shop.who-body":
      "Nobody until they choose it themselves. Members only see which of the members taking part have which wine.",
    "social.shop.done": "Done",
    "social.shop.off-confirm-title": "Switch the wine list off?",
    "social.shop.off-confirm-body":
      "The list disappears for everyone in the group and all shared ticks of this group are erased. Personal ticks stay. You can switch it on again later, with an empty list.",
    "social.shop.off-confirm-yes": "Switch off and erase the shared ticks",
    "social.shop.off-confirm-no": "Keep it on",
    "social.shop.offer-title": "Share what you have with {group}",
    "social.shop.offer-body":
      "The group sees which wines you ticked, with your name. What you already ticked for level {n} comes along. You can stop at any time.",
    "social.shop.offer-yes": "Share with the group",
    "social.shop.offer-no": "Not now",
    "social.shop.stop": "Stop sharing",
    "social.shop.sharing-count": "{n} members share",
    "social.shop.sharing-count-1": "1 member shares",
    "social.shop.nobody-sharing": "Nobody shares yet",
    "social.shop.you-share": "You are sharing with this group.",
    "social.shop.has-you": "You have this",
    "social.shop.has-you-and": "You and {name} have this",
    "social.shop.has-you-and-many": "You and {names} have this",
    "social.shop.has-one": "{name} has this",
    "social.shop.has-many": "{names} have this",
    "social.shop.nobody": "Nobody has this yet",
    "social.shop.ask-title": "Share with {group}?",
    "social.shop.ask-body":
      "If you share this tick, the group sees it with your name, together with your other ticks for level {n}. If you choose 'Only for me', you tick your own list only.",
    "social.shop.ask-share": "Share and tick",
    "social.shop.ask-private": "Only for me",
    "social.shop.offline": "No connection. This is the last list seen and it may be out of date.",
    "social.shop.last-seen": "last seen {when}",
    "social.shop.error-title": "The group's list could not be loaded",
    "social.shop.error-body": "The rest of the group works as usual. Try again shortly.",
    "social.shop.retry": "Try again",
    "social.shop.off-notice": "This group's wine list is switched off.",
    "social.shop.share-list": "Share the list",
    "notify.shop.inbox-item": "{name} has a wine on the list of {group}",
    "notify.shop.offline-open":
      "No connection. You see the last saved list; it may be out of date.",
  },
} as const;
